
import './styles.scss';

const Lable = (props) => {
    const {
        lable
    } = props;

    return <div class="component-label">
        {lable} :
    </div>
}

export default Lable;